import { render, staticRenderFns } from "./OwnerHistory.vue?vue&type=template&id=61fcc856"
import script from "./OwnerHistory.vue?vue&type=script&lang=js"
export * from "./OwnerHistory.vue?vue&type=script&lang=js"
import style0 from "./OwnerHistory.vue?vue&type=style&index=0&id=61fcc856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports